module.exports = __webpack_public_path__ + "static/media/yappe-mobile.14e4fbdc.png";